module.exports = __webpack_public_path__ + "assets/3-vp-sales-recruiters.c0719f94.png";